import React, { useState, useEffect } from "react";
import Logo from "../../images/hoop.png";
const BalanceSheet = () => {
  // Mock data
  const mockClasses = [
    { class_name: "Nursery" },
    { class_name: "LKG" },
    { class_name: "UKG" },
    { class_name: "Grade 1" },
    { class_name: "Grade 2" },
  ];

  const mockStudents = {
    Nursery: [
      {
        studentId: "N001",
        firstName: "Aarav",
        middleName: "",
        lastName: "Sharma",
      },
      {
        studentId: "N002",
        firstName: "Diya",
        middleName: "Kumari",
        lastName: "Patel",
      },
    ],
    LKG: [
      {
        studentId: "L001",
        firstName: "Rohan",
        middleName: "",
        lastName: "Joshi",
      },
      {
        studentId: "L002",
        firstName: "Priya",
        middleName: "",
        lastName: "Verma",
      },
    ],
    UKG: [
      {
        studentId: "U001",
        firstName: "Arjun",
        middleName: "",
        lastName: "Singh",
      },
      {
        studentId: "U002",
        firstName: "Ananya",
        middleName: "",
        lastName: "Gupta",
      },
    ],
    "Grade 1": [
      {
        studentId: "G1001",
        firstName: "Vihaan",
        middleName: "",
        lastName: "Malhotra",
      },
      {
        studentId: "G1002",
        firstName: "Ishaan",
        middleName: "",
        lastName: "Reddy",
      },
    ],
    "Grade 2": [
      {
        studentId: "G2001",
        firstName: "Aditi",
        middleName: "",
        lastName: "Nair",
      },
      {
        studentId: "G2002",
        firstName: "Kabir",
        middleName: "",
        lastName: "Mehta",
      },
    ],
  };

  const mockBalanceData = {
    N001: [
      {
        student_id: "N001",
        class_name: "Nursery",
        fee_month: "January 2023",
        total_fee: "5000.00",
        total_paid: "3000.00",
        balance_due: "2000.00",
      },
      {
        student_id: "N001",
        class_name: "Nursery",
        fee_month: "February 2023",
        total_fee: "5000.00",
        total_paid: "5000.00",
        balance_due: "0.00",
      },
    ],
    L001: [
      {
        student_id: "L001",
        class_name: "LKG",
        fee_month: "January 2023",
        total_fee: "5500.00",
        total_paid: "5500.00",
        balance_due: "0.00",
      },
      {
        student_id: "L001",
        class_name: "LKG",
        fee_month: "February 2023",
        total_fee: "5500.00",
        total_paid: "3000.00",
        balance_due: "2500.00",
      },
    ],
    U001: [
      {
        student_id: "U001",
        class_name: "UKG",
        fee_month: "January 2023",
        total_fee: "6000.00",
        total_paid: "6000.00",
        balance_due: "0.00",
      },
    ],
    G1001: [
      {
        student_id: "G1001",
        class_name: "Grade 1",
        fee_month: "January 2023",
        total_fee: "6500.00",
        total_paid: "4000.00",
        balance_due: "2500.00",
      },
    ],
    G2001: [
      {
        student_id: "G2001",
        class_name: "Grade 2",
        fee_month: "January 2023",
        total_fee: "7000.00",
        total_paid: "7000.00",
        balance_due: "0.00",
      },
      {
        student_id: "G2001",
        class_name: "Grade 2",
        fee_month: "February 2023",
        total_fee: "7000.00",
        total_paid: "3500.00",
        balance_due: "3500.00",
      },
      {
        student_id: "G2001",
        class_name: "Grade 2",
        fee_month: "March 2023",
        total_fee: "7000.00",
        total_paid: "0.00",
        balance_due: "7000.00",
      },
    ],
  };

  const [students, setStudents] = useState([]);
  const [classes, setClasses] = useState([]);
  const [selectedStudentId, setSelectedStudentId] = useState("");
  const [selectedStudentName, setSelectedStudentName] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [balanceSheetData, setBalanceSheetData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Simulate fetching classes
  useEffect(() => {
    setLoading(true);
    // Simulate API delay
    setTimeout(() => {
      setClasses(mockClasses);
      setLoading(false);
    }, 500);
  }, []);

  // Simulate fetching students for the selected class
  useEffect(() => {
    if (selectedClass) {
      setLoading(true);
      // Simulate API delay
      setTimeout(() => {
        setStudents(mockStudents[selectedClass] || []);
        setLoading(false);
      }, 500);
    } else {
      setStudents([]);
    }
  }, [selectedClass]);

  // Auto-search when both class and student are selected
  useEffect(() => {
    if (selectedClass && selectedStudentId) {
      handleSearch();
    }
  }, [selectedClass, selectedStudentId]);

  const handleSearch = () => {
    setLoading(true);
    setError("");

    // Simulate API delay
    setTimeout(() => {
      try {
        if (selectedStudentId) {
          setBalanceSheetData(mockBalanceData[selectedStudentId] || []);
          if (!mockBalanceData[selectedStudentId]) {
            setError("No balance data found for this student");
          }
        } else if (selectedClass) {
          // If only class is selected, show all students' balance in that class
          const classStudents = mockStudents[selectedClass] || [];
          const allBalances = classStudents.flatMap(
            (student) => mockBalanceData[student.studentId] || []
          );
          setBalanceSheetData(allBalances);
          if (allBalances.length === 0) {
            setError("No balance data found for this class");
          }
        } else {
          setError("Please select a class or enter a student ID.");
        }
        setLoading(false);
      } catch (error) {
        setError("Failed to fetch balance sheet");
        setLoading(false);
      }
    }, 800);
  };

  const printBalanceSheet = () => {
    const printContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Student Ledger</title>
          <style>
            @page { size: A4; margin: 15mm; }
            body { font-family: Arial, sans-serif; margin: 0; padding: 0; line-height: 1.5; }
            .container { max-width: 100%; margin: 0 auto; }
            .header { text-align: center; margin-bottom: 30px; }
            .header img { width: 100px; margin-bottom: 10px; }
            .header h1 { font-size: 22px; margin: 5px 0; color: #2d3748; }
            .header p { margin: 3px 0; color: #4a5568; font-size: 12px; }
            .meta-info { margin: 20px 0; padding: 10px; background: #f8f9fa; border-radius: 5px; }
            .meta-info p { margin: 5px 0; font-size: 13px; color: #2d3748; }
            table { width: 100%; border-collapse: collapse; margin: 20px 0; }
            th, td { 
              border: 1px solid #718096; 
              padding: 10px; 
              text-align: left; 
              font-size: 12px;
            }
            th { background: #f7fafc; font-weight: bold; color: #2d3748; }
            td { color: #4a5568; }
            .amount { text-align: right; }
            .footer {
              margin-top: 40px;
              text-align: right;
              page-break-inside: avoid;
            }
            .signature-line {
              width: 200px;
              border-top: 1px solid #000;
              margin-left: auto;
              margin-bottom: 5px;
            }
            .sign-text { 
              font-size: 12px;
              color: #4a5568;
              margin-top: 5px;
            }
            .print-date {
              position: absolute;
              bottom: 20px;
              left: 0;
              font-size: 11px;
              color: #718096;
            }
          </style>
        </head>
        <body>
          <div class="container">
            <div class="header">
              <img src="${Logo}" alt="Logo" />
              <h1>HOOP</h1>
              <p>Email: info@bluebugsoft.com | Phone: 9829303050</p>
              <p>Address: Kathmandu, Nepal</p>
            </div>

            <h2 style="text-align: center; color: #2d3748; margin: 30px 0;">Student Ledger</h2>
            
            <div class="meta-info">
             ${
               selectedClass
                 ? `<p><strong>Student Name:</strong> ${selectedStudentName}</p>`
                 : ""
             }
              ${
                selectedClass
                  ? `<p><strong>Class:</strong> ${selectedClass}</p>`
                  : ""
              }
              ${
                selectedStudentId
                  ? `<p><strong>Student ID:</strong> ${selectedStudentId}</p>`
                  : ""
              }
            </div>

            <table>
              <thead>
                <tr>
                  <th>Student ID</th>
                  <th>Class</th>
                  <th>Fee Month</th>
                  <th style="text-align: right">Total Fee</th>
                  <th style="text-align: right">Paid Amount</th>
                  <th style="text-align: right">Balance Due</th>
                </tr>
              </thead>
              <tbody>
                ${balanceSheetData
                  .map(
                    (item) => `
                  <tr>
                    <td>${item.student_id}</td>
                    <td>${item.class_name}</td>
                    <td>${item.fee_month}</td>
                    <td class="amount">Rs. ${parseFloat(item.total_fee).toFixed(
                      2
                    )}</td>
                    <td class="amount">Rs. ${parseFloat(
                      item.total_paid
                    ).toFixed(2)}</td>
                    <td class="amount">Rs. ${parseFloat(
                      item.balance_due
                    ).toFixed(2)}</td>
                  </tr>
                `
                  )
                  .join("")}
              </tbody>
            </table>

            <div class="footer">
              <div class="signature-line"></div>
              <p class="sign-text">Authorized Signature</p>
            </div>

            <p class="print-date">Generated on: ${new Date().toLocaleDateString(
              "en-US",
              {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              }
            )}</p>
          </div>
        </body>
      </html>
    `;

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    iframe.contentWindow.document.write(printContent);
    iframe.contentWindow.document.close();

    iframe.onload = function () {
      try {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 1000);
      } catch (error) {
        console.error("Printing failed:", error);
        document.body.removeChild(iframe);
      }
    };
  };

  return (
    <div
      className="balance-page fix-height box"
      style={{ maxWidth: "1200px", margin: "0 auto", padding: "20px" }}
    >
      <h1
        className="main-heading"
        style={{ color: "#2d3748", textAlign: "center", marginBottom: "30px" }}
      >
        Student Ledger
      </h1>

      <div
        className="form-row"
        style={{
          display: "flex",
          gap: "20px",
          marginBottom: "20px",
          flexWrap: "wrap",
        }}
      >
        <div className="form-group" style={{ flex: "1", minWidth: "200px" }}>
          <label
            htmlFor="class"
            style={{ display: "block", marginBottom: "5px", fontWeight: "500" }}
          >
            Class:
          </label>
          <select
            className="form-control"
            id="class"
            value={selectedClass}
            onChange={(e) => {
              setSelectedClass(e.target.value);
              setSelectedStudentId("");
            }}
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "4px",
              border: "1px solid #cbd5e0",
              backgroundColor: "#fff",
            }}
          >
            <option value="">Select Class</option>
            {classes.map((cls) => (
              <option key={cls.class_name} value={cls.class_name}>
                {cls.class_name}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group" style={{ flex: "1", minWidth: "200px" }}>
          <label
            htmlFor="student"
            style={{ display: "block", marginBottom: "5px", fontWeight: "500" }}
          >
            Student:
          </label>
          <select
            id="student"
            className="form-control"
            value={selectedStudentId}
            onChange={(e) => {
              const selectedStudent = students.find(
                (s) => s.studentId === e.target.value
              );
              setSelectedStudentId(e.target.value);
              setSelectedStudentName(
                selectedStudent
                  ? `${selectedStudent.firstName} ${selectedStudent.middleName} ${selectedStudent.lastName}`.trim()
                  : ""
              );
            }}
            disabled={!selectedClass}
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "4px",
              border: "1px solid #cbd5e0",
              backgroundColor: "#fff",
              opacity: selectedClass ? "1" : "0.7",
            }}
          >
            <option value="">Select a student</option>
            {students.map((student) => (
              <option key={student.studentId} value={student.studentId}>
                {`${student.firstName} ${student.middleName} ${student.lastName}`.trim()}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div
        className="action-buttons"
        style={{ display: "flex", gap: "15px", marginBottom: "30px" }}
      >
        <button
          className="search-btn"
          onClick={handleSearch}
          disabled={loading}
          style={{
            padding: "10px 20px",
            backgroundColor: "#4299e1",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            opacity: loading ? "0.7" : "1",
          }}
        >
          {loading ? "Searching..." : "Search"}
        </button>
        <button
          className="print-btn"
          onClick={printBalanceSheet}
          disabled={balanceSheetData.length === 0}
          style={{
            padding: "10px 20px",
            backgroundColor:
              balanceSheetData.length === 0 ? "#cbd5e0" : "#48bb78",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: balanceSheetData.length === 0 ? "not-allowed" : "pointer",
          }}
        >
          Print Balance Sheet
        </button>
      </div>

      {error && (
        <div
          className="error"
          style={{ color: "#e53e3e", marginBottom: "20px" }}
        >
          {error}
        </div>
      )}

      <div className="table-container" style={{ overflowX: "auto" }}>
        {!balanceSheetData.length && !loading ? (
          <div
            className="balance-empty-state"
            style={{
              textAlign: "center",
              padding: "40px",
              backgroundColor: "#f8f9fa",
              borderRadius: "8px",
              color: "#4a5568",
            }}
          >
            <div
              className="empty-icon"
              style={{ fontSize: "50px", marginBottom: "20px" }}
            >
              📊
            </div>
            <div
              className="empty-text"
              style={{
                fontSize: "18px",
                fontWeight: "500",
                marginBottom: "10px",
              }}
            >
              No Balance Sheet Data Available
            </div>
            <div className="empty-subtext" style={{ fontSize: "14px" }}>
              Select a class as well as student and search to view balance
              details
            </div>
          </div>
        ) : (
          <table
            className="table"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#f7fafc" }}>
                <th
                  style={{
                    padding: "12px",
                    border: "1px solid #e2e8f0",
                    textAlign: "left",
                  }}
                >
                  Student ID
                </th>
                <th
                  style={{
                    padding: "12px",
                    border: "1px solid #e2e8f0",
                    textAlign: "left",
                  }}
                >
                  Class
                </th>
                <th
                  style={{
                    padding: "12px",
                    border: "1px solid #e2e8f0",
                    textAlign: "left",
                  }}
                >
                  Fee Month
                </th>
                <th
                  style={{
                    padding: "12px",
                    border: "1px solid #e2e8f0",
                    textAlign: "right",
                  }}
                >
                  Total Fee
                </th>
                <th
                  style={{
                    padding: "12px",
                    border: "1px solid #e2e8f0",
                    textAlign: "right",
                  }}
                >
                  Paid Amount
                </th>
                <th
                  style={{
                    padding: "12px",
                    border: "1px solid #e2e8f0",
                    textAlign: "right",
                  }}
                >
                  Balance Due
                </th>
              </tr>
            </thead>
            <tbody>
              {balanceSheetData.length > 0 ? (
                balanceSheetData.map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 0 ? "#fff" : "#f8f9fa",
                      ":hover": { backgroundColor: "#ebf8ff" },
                    }}
                  >
                    <td
                      style={{ padding: "12px", border: "1px solid #e2e8f0" }}
                    >
                      {item.student_id}
                    </td>
                    <td
                      style={{ padding: "12px", border: "1px solid #e2e8f0" }}
                    >
                      {item.class_name}
                    </td>
                    <td
                      style={{ padding: "12px", border: "1px solid #e2e8f0" }}
                    >
                      {item.fee_month}
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        border: "1px solid #e2e8f0",
                        textAlign: "right",
                      }}
                    >
                      Rs. {item.total_fee}
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        border: "1px solid #e2e8f0",
                        textAlign: "right",
                      }}
                    >
                      Rs. {item.total_paid}
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        border: "1px solid #e2e8f0",
                        textAlign: "right",
                        color:
                          parseFloat(item.balance_due) > 0
                            ? "#e53e3e"
                            : "#38a169",
                        fontWeight:
                          parseFloat(item.balance_due) > 0 ? "500" : "normal",
                      }}
                    >
                      Rs. {item.balance_due}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="6"
                    className="empty-state"
                    style={{
                      padding: "20px",
                      textAlign: "center",
                      border: "1px solid #e2e8f0",
                      color: "#718096",
                    }}
                  >
                    {loading ? "Loading..." : "No data available"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default BalanceSheet;
